import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  isScrollToFirstError: boolean;
  formErrors: Record<string, string>;
}

const initialState: InitialState = {
  isScrollToFirstError: false,
  formErrors: {},
};

export type ErrorsType =
  | {
      isScrollToFirstError: boolean;
      formErrors: Record<string, string>;
    }
  | ((currentState: {
      isScrollToFirstError: boolean;
      formErrors: Record<string, string>;
    }) => {
      isScrollToFirstError: boolean;
      formErrors: Record<string, string>;
    });

export interface ValidationPayload {
  key: string;
  payload: ErrorsType;
}

const validationSlice = createSlice({
  name: "validation",
  initialState,
  reducers: {
    changeFormErrors: (state, action: PayloadAction<ValidationPayload>) => {
      const currentState = state[action.payload.key] || {};
      const newErrors =
        typeof action.payload.payload === "function"
          ? action.payload.payload(currentState)
          : action.payload.payload;

      state[action.payload.key] = newErrors;
    },
  },
});

export const { changeFormErrors } = validationSlice.actions;

export default validationSlice.reducer;
